import { Button, Flex, Heading, useColorMode } from '@chakra-ui/core';
import { useObserver } from 'mobx-react';
import React, { useEffect } from 'react';
import { FaSpotify } from 'react-icons/fa';
import { useHistory } from 'react-router';

import { useStores } from '../hooks/useStores';

function useStoreData() {
    const { store } = useStores();
    return useObserver(() => ({
        signIn: store.auth.signIn,
        isAuthenticated: store.auth.isAuthenticated,
        userRole: store.auth.role,
    }));
}

const SignIn: React.FC = () => {
    const { signIn, isAuthenticated } = useStoreData();
    const { colorMode } = useColorMode();
    const history = useHistory();
    const bgColor = { light: 'gray.50', dark: 'gray.800' };
    const color = { light: 'gray.800', dark: 'gray.50' };
    useEffect(() => {
        if (isAuthenticated) {
            history.replace('/');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <Flex
            direction="column"
            bg={bgColor[colorMode]}
            color={color[colorMode]}
            minH="100vh"
            alignItems="center"
            justifyContent="center"
        >
            <Heading m="1rem">One Playlist</Heading>
            <Button size="lg" variant="ghost" rightIcon={FaSpotify} onClick={signIn}>
                Sign in with
            </Button>
        </Flex>
    );
};

export default SignIn;
